import { Inject, Injectable } from '@angular/core';
import { DevagramApiService } from '../shared/servicos-login/devagram-api.service';
import { CredenciaisPortal } from './credenciaisPortal.type';
import { RespostaLoginPortal } from './resposta-login-devagram.type';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DevagramUsuarioApiService } from '../shared/servicos-login/devagram-usuario-api.service';
import { UsuarioLogado } from './usuario-logado.type';
import { ApiService } from '../services/contratos/contratos.service';


@Injectable({
  providedIn: 'root'
})
export class AutenticacaoService extends DevagramApiService{
  [x: string]: any;
  private isLoggedIn = false;
  private userAccessLevel: number = 0; // Adicione esta propriedade
  private userLogin: string = ''; // Adicione esta propriedade
  private userflowsAccess: string[] = []; // Adicione esta propriedade
  private userflows: string = ''; // Adicione esta propriedade
  private usercompany: string = ''; // Adicione esta propriedade
  queryUsers: string = 'usersPortal';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  users: any[] = [];
  
  

  constructor(
    private dynamodbService: ApiService,
    protected _http: HttpClient,
    @Inject('LOGIN_URL_API') private _loginUrlApi:string,
    private router: Router,
    private usuarioApiService: DevagramUsuarioApiService
  ) {
    super(_http, _loginUrlApi)
  }
  
  // async ngOnInit(): Promise<void> {
  //   await this.getUser();
  //   const storedUserAccessLevel = this.users[0].role;
  //   this.userAccessLevel = storedUserAccessLevel ? JSON.parse(storedUserAccessLevel) : 0;
  // }

  async login(credenciais: CredenciaisPortal): Promise<void> {
    const respostaLogin: RespostaLoginPortal = await this.post('', credenciais)
    // //console.log(respostaLogin)
    if (!respostaLogin.auth_token) {
      throw new Error('Login invalido!')
    }
    this.userAccessLevel = parseInt(respostaLogin.role); // Defina o nível de acesso do usuário
    this.userLogin = respostaLogin.Id; // Defina o nível de acesso do usuário
    // //console.log(respostaLogin)
    localStorage.setItem("token", respostaLogin.auth_token)
    // localStorage.setItem("nome", respostaLogin.nome)
    localStorage.setItem("email", respostaLogin.Id)
    // localStorage.setItem("role", respostaLogin.role)
    // localStorage.setItem("flows", JSON.stringify(respostaLogin.flowsAccess))
    // localStorage.setItem("company", respostaLogin.company)
    // localStorage.setItem('userAccessLevel', JSON.stringify(this.userAccessLevel));
    // //pegar dados complementares do usuario logado
    // const dadosUsuario = await this.usuarioApiService.buscarDadosUsuarios();
    // localStorage.setItem("id", dadosUsuario._id);
    // await this.getUser();
    await this.updateLoggedIn();
    // Simulando permissões do usuário e nível de acesso (pode ser obtido do servidor)
    this.userflowsAccess = respostaLogin.flowsAccess; // Defina o nível de acesso do usuário
    this.usercompany = respostaLogin.company; // Defina o nível de acesso do usuário
    this.router.navigateByUrl('/');
  }

  estaLogado(): boolean {
    return localStorage.getItem('token') != null;
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('nome');
    localStorage.removeItem('email');
    localStorage.removeItem('id');
    localStorage.removeItem('role');
    localStorage.removeItem('flows');
    localStorage.removeItem('company');
    localStorage.removeItem('userAccessLevel');
    localStorage.clear();
    //redirecionar login
    this.updateLoggedIn();
    this.userAccessLevel = 0;
    this.obterUsuarioLogado();
    this.router.navigateByUrl('/login');
  }


  //devolver detalhes do usuario logado
  async obterUsuarioLogado(): Promise<UsuarioLogado> {
    if (!this.estaLogado()) {
      //console.log("sem user logado")
      return {
        id: "",
        nome: "",
        role: "",
        flows: "",
        company: "",
      } as UsuarioLogado
    } else {
      await this.getUser();
      // //console.log(this.users)
      if (this.users.length > 0) {
        return {
          // id: localStorage.getItem('email'),
          // nome: localStorage.getItem('nome'),
          // role: localStorage.getItem('role'),
          // flows: localStorage.getItem('flows'),
          // company: localStorage.getItem('company'),
          id: this.users[0].ID,
          nome: this.users[0].nome,
          role: this.users[0].role,
          flows: this.users[0].flows,
          company: this.users[0].company,
        } as UsuarioLogado
      } else {
        return {
          id: "",
          nome: "",
          role: "",
          flows: "",
          company: "",
        } as UsuarioLogado
      }
    }
  }
  
  async getUser(): Promise<UsuarioLogado | null> {
    const filtroUser = '';
    const id = localStorage.getItem('email')
    try {
      const response = await (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).toPromise();

      if (response.statusCode === 200) {
        const userArray = JSON.parse(response.body);
        // //console.log(userArray)
        // //console.log(id)

        if (Array.isArray(userArray)) {

          const user = userArray.find(item => item.ID === id);
          if (user) {
            this.users = [user];
            return user;
          } else {
            console.error('User not found.');
            return null;
          }
        } else {
          console.error('Invalid items data:', userArray);
          return null;
        }
      } else {
        console.error('Invalid response:', response);
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      return null;
    }
  }

  
  // Método para verificar se o usuário está autenticado
  isUserLoggedIn(): boolean {
    return this.isLoggedIn;
  }
  
  // Método para obter o nível de acesso do usuário
  async getUserAccessLevel(): Promise<[number, string]> {
    await this.getUser();
    // //console.log(this.users[0])
    if (!this.users[0]) {
      this.router.navigateByUrl('/login');
      return [0,""]
    } else {
      const storedUserAccessLevel = this.users[0] ? this.users[0].role : 0;
      this.userAccessLevel = storedUserAccessLevel ? JSON.parse(storedUserAccessLevel) : 0;
      return [this.userAccessLevel, this.users[0].company];
    }
  }
  
  async updateLoggedIn(): Promise<void> {
    // //console.log("entrou loged in")
    const token = localStorage.getItem('token');
    // await this.getUserAccessLevel();
    // await this.getUser();
    // const storedUserAccessLevel = this.users[0].role;
    // this.userAccessLevel = storedUserAccessLevel ? JSON.parse(storedUserAccessLevel) : 0;
    // const role = await this.getUserAccessLevel();
    const [accessLevel, userCompany] = await this.getUserAccessLevel();
    // //console.log("role")
    // //console.log(this.userAccessLevel)
    if (accessLevel) {
      this.userAccessLevel = accessLevel;
      this['userCompany'] = userCompany;
      // //console.log(this['userCompany'])
      if (token) {
        // //console.log("true")
        this.isLoggedIn = true;
      } else {
        // //console.log("false")
        this.isLoggedIn = false;
      }
    }
  }
  
}


